import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Sparkles, Loader2, AlertCircle } from "lucide-react";
import { api } from "@/lib/api";
import { Shell } from "@/components/site/Shell";

const COPY = {
  donation: ["Thank you for your gift", "Your love offering has been received. It helps keep the circle open for every soul who needs it."],
};

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ phase: "checking" });

  useEffect(() => {
    if (!sessionId) return setState({ phase: "error" });
    let tries = 0, timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") return setState({ phase: "paid", kind: data.kind });
        if (["expired", "cancelled", "failed"].includes(data.payment_status)) return setState({ phase: "error" });
      } catch {}
      if (++tries >= 10) return setState({ phase: "timeout" });
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  if (state.phase === "checking") {
    return <Shell testId="payment-checking"><Loader2 className="mx-auto text-gold animate-spin" size={36} /><p className="mt-6 font-cinzel tracking-widest text-[#f1d57a]">Confirming your payment...</p></Shell>;
  }
  if (state.phase !== "paid") {
    return (
      <Shell testId="payment-error">
        <AlertCircle className="mx-auto text-gold" size={36} strokeWidth={1.4} />
        <h1 className="font-display gold-text text-3xl md:text-4xl mt-6">{state.phase === "timeout" ? "Still processing" : "Payment not completed"}</h1>
        <p className="mt-5 text-[#f7f1e1]/80">{state.phase === "timeout" ? "Your payment is taking a little longer to confirm. Please refresh this page in a moment." : "We could not confirm this payment. You have not been charged."}</p>
      </Shell>
    );
  }
  const [title, text] = COPY.donation;
  return (
    <Shell testId="payment-success">
      <Sparkles className="mx-auto text-gold" size={40} strokeWidth={1.3} />
      <p className="eyebrow mt-6">Thank you, beloved soul</p>
      <h1 className="font-display gold-text text-3xl md:text-4xl mt-3" data-testid="payment-success-title">{title}</h1>
      <p className="mt-5 text-[#f7f1e1]/80 leading-relaxed">{text}</p>
      <p className="italic text-[#f1d57a] mt-6">"Transmute pain into purpose"</p>
    </Shell>
  );
}
